import { omit } from "lodash"

const registrationEventPath = "/registrations/v2/events/:eventId"

export const registrations = {
  organization: "/registrations/v2",
  events: "/registrations/v2/events",
  registration: `/registrations/v2/registrations/:registrationId`,
  answers: `/registrations/v2/registrations/:registerableId/answers`,
  answer: `/registrations/v2/registrations/:registerableId/answers/:answerId`,
  event: registrationEventPath,
  reservations: `${registrationEventPath}/reservations`,
  reservation: `${registrationEventPath}/reservations/:reservationUuid`,
  attendeeTypes: `${registrationEventPath}/attendee_types`,
  addOns: `${registrationEventPath}/add_ons`,
  questions: `${registrationEventPath}/questions`,
  paymentIntents: `${registrationEventPath}/reservations/:reservationUuid/payment_intents`,
  paymentIntent: `${registrationEventPath}/reservations/:reservationUuid/payment_intent`,
}

export const people = {
  households: "/people/v2/people/:personId/households",
  guests: "/people/v2/guests",
}

export const routes = {
  registrations,
  people,
}

export const buildPath = (route, options = {}) => {
  let opts = options

  const path = route.replace(/:[a-zA-Z?]+/g, (match) => {
    const param = match.slice(1)
    opts = omit(opts, [param])

    if (!options[param]) {
      throw new Error(`Missing required path params for ${match}`)
    }

    return options[param]
  })

  return [path, opts]
}

export const urlParamsToString = (path, options = {}) => {
  const params = Object.keys(options)
    .map((key) => `${key}=${options[key]}`)
    .join("&")

  return `${path}${params ? `?${params}` : ""}`
}
